
class ShareApplicationController {

    static $inject = ['application']
    constructor(public application) {}        
}

angular
    .module('app')
    .controller('ShareApplicationController', ShareApplicationController)